import { render, staticRenderFns } from "./OnboardingPage.vue?vue&type=template&id=87a45618&"
import script from "./OnboardingPage.vue?vue&type=script&lang=js&"
export * from "./OnboardingPage.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports